import { initializeApp } from 'firebase'

var fb = initializeApp({
    apiKey: "AIzaSyDGTjOt7344VSdlByA7wpepkjTgYuYw0xI",
    authDomain: "ev-desafio.firebaseapp.com",
    databaseURL: "https://ev-desafio.firebaseio.com",
    projectId: "ev-desafio",
    storageBucket: "ev-desafio.appspot.com",
    messagingSenderId: "390255482939",
    appId: "1:390255482939:web:e027c933e91900f4"
});

export var db = fb.database();
export var auth = fb.auth();